module.exports = __webpack_public_path__ + "static/media/sundance1.303994b7.jpg";